import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

const ShortIronCondorSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M1.02042 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1 18.0225H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1.02042 25.0535H7.69475L9.61997 18.0225" stroke="#A40C0C" strokeWidth="2"/>
        <path d="M31.1189 25.0535H24.4445L22.5193 18.0225" stroke="#A40C0C" strokeWidth="2"/>
        <path d="M9.61997 18.0225L13.2447 3.96043H19.3095L22.5193 18.0225" stroke="#089981" strokeWidth="2"/>
    </svg>
)
const ShortIronCondor: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {ShortIronCondorSvg(props)}
    </SvgIcon>
));
export default ShortIronCondor